<template>
	<div class="engagement-list">
		<div class="event-header">
			{{ profileName }} Events
		</div>
		<div class="event-list" v-if="eventList">
			<a
				class="event-link"
				:key="event.id"
				:href="'#' + event.id"
				v-for="event in eventList">
				{{ event.name }}
			</a>
		</div>
	</div>
	
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'engagement-list',
	props: {
		eventList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			
		}
	},
	computed: {
		...mapGetters('provider', ['getProviderProfile']),
		profileName() {
			return this.getProviderProfile(this.$route.params.profileId) ? this.getProviderProfile(this.$route.params.profileId).title : null
		}
	}
}
</script>


<style lang="scss" scoped>
	.engagement-list{
		width: 150px;
	}
	.event-header{
		padding: 10px 20px;
		font-weight: 700;
	}
	.event-list{
		display: flex;
		flex-direction: column;
	}
	.event-link{
		font-size: 12px;
		padding: 12px 18px;
		text-decoration: none;
		color: #333333;
		transition: background-color 0.5s ease;
		text-transform: capitalize;
	}
	.event-link:hover{
		background-color: #abd5ff
	}
</style>
